export default "__VITE_ASSET__CFInmO0K__"